import React from 'react';
import {
    CheckCircleIcon,
    ClockIcon,
    LockClosedIcon,
    ExclamationTriangleIcon,
    XCircleIcon,
    ArrowPathIcon,
} from '@heroicons/react/24/outline';

const VARIANTS = {
    approved: { className: 'badge-success', Icon: CheckCircleIcon, label: 'Approved' },
    completed: { className: 'badge-success', Icon: CheckCircleIcon, label: 'Completed' },
    verified: { className: 'badge-success', Icon: CheckCircleIcon, label: 'Verified' },
    submitted: { className: 'badge-info', Icon: ClockIcon, label: 'Submitted' },
    pending: { className: 'badge-warning', Icon: ClockIcon, label: 'Pending' },
    in_progress: { className: 'badge-brand', Icon: ArrowPathIcon, label: 'In Progress' },
    needs_update: { className: 'badge-warning', Icon: ExclamationTriangleIcon, label: 'Needs Update' },
    returned: { className: 'badge-warning', Icon: ExclamationTriangleIcon, label: 'Needs Update' },
    rejected: { className: 'badge-danger', Icon: XCircleIcon, label: 'Rejected' },
    locked: { className: 'badge-neutral', Icon: LockClosedIcon, label: 'Locked' },
    draft: { className: 'badge-neutral', Icon: ClockIcon, label: 'Draft' },
    private: { className: 'badge-neutral', Icon: LockClosedIcon, label: 'Private' },
    public: { className: 'badge-info', Icon: CheckCircleIcon, label: 'Public' },
};

/**
 * Status badge with icon + text (never color-only).
 */
export default function StatusBadge({ status, label, className = '' }) {
    const key = String(status || '')
        .toLowerCase()
        .replace(/\s+/g, '_');
    const config = VARIANTS[key] || {
        className: 'badge-neutral',
        Icon: ClockIcon,
        label: label || status || 'Status'
    };
    const Icon = config.Icon;
    const text = label || config.label;

    return (
        <span className={`badge ${config.className} ${className}`}>
            <Icon className="h-3.5 w-3.5" aria-hidden="true" />
            <span>{text}</span>
        </span>
    );
}
